import { ICommonIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It renders a note/camera like icon with a checkmark on bottom right.
 */
export function BankNoteCheckMarkIcon({
  className,
}: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M10 17.002H5.496a2.501 2.501 0 0 1-2.5-2.501V6.498a2.501 2.501 0 0 1 2.5-2.501h12.005a2.501 2.501 0 0 1 2.501 2.5V10M17.002 6.998h-1M5.997 14.001h1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <circle
        cx={17.502}
        cy={16.502}
        r={4.502}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m19.016 15.61-1.89 1.89-1.138-1.133M9.731 12.268a2.501 2.501 0 0 1 3.537-3.537"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
